import { Injectable } from "@angular/core";
import { environment } from "@envs/environment";
import { RequestService } from "clicklease-ui-elements";
import { map, Observable } from "rxjs";

/**
 * @service
 * @class RiskManagerGatewayRequestService
 */
@Injectable({
    providedIn: 'root',
})
export class BankInfoRequestService extends RequestService {

    protected override readonly serviceBaseUrl: string = `${environment.API_URL}bank-info/`;

    public getBankInfo(routingNumber: string): Observable<any> {
        return this.get<any>({
            url: `bank-info/${routingNumber}/bankname`,
            headers: {
                'content-type': 'application/json'
            }
        }).pipe(map((response: any) => response))
    }
}